module.exports = __webpack_public_path__ + "img/首页品牌卢卡斯.png";